import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { getFiltrarLocales, getFiltrarPromociones, getFiltroReporte, postGiftCardReporte, postReporteCaja } from "../../../../api/ApiService";
import { Download, FileSpreadsheet } from "lucide-react";
import { useSelector } from "react-redux";
import ReportePaseoPlus from "./components/ReportePaseoPlus";
import ReportesGiftCard from "./components/ReportesGiftCard";


export const statusOptionsPaseoPlus = [
    { label: "Reporte de Vales", value: "Reporte de Vales", id: 1 },
    { label: "Reporte de Canjes", value: "Reporte de Canjes", id: 2 },
];

function ReportesPage() {
    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const [loadingCargar, setLoadingCargar] = useState(false);


    //seccionde paseo plus
    const [dataPromociones, setDataPromociones] = useState([]);
    const [tipoReportes, setTipoReportes] = useState([]);
    const [tipoReportePaseo, setTipoReportePaseo] = useState('');
    
    const [buscarPromocion, setBuscarPromocion] = useState('');
    const [promocionesData, setPromocionesData] = useState([]);
    const [loadingPromociones, setLoadingPromociones] = useState(false);
    const [promocionSelected, setPromocionSelected] = useState(null);

    const [buscarLocal, setBuscarLocal] = useState('');
    const [localesData, setLocalesData] = useState([]);
    const [loadingLocales, setLoadingLocales] = useState(false);
    const [localSelected, setLocalSelected] = useState(null);



    //estado alert
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');





    const handleClose = () => {
        setOpen(false);
    };


    //============================================================ funcion para obtener los filtros de Paseo Plus
    const handleApiFiltrosOpciones = () => {



        setLoadingPromociones(true);
        setLoadingLocales(true);

        getFiltroReporte(stateToken?.access_token)
            .then(response => {
                // console.log("response==>getFiltroReporte", response);
                setLoadingPromociones(false);
                setLoadingLocales(false);

                if (response?.data?.promociones?.length > 0) {
                    setDataPromociones(response.data.promociones);
                } else {
                    setDataPromociones([]);
                }

                if (response?.data?.locales?.length > 0) {
                    setLocalesData(response.data.locales);
                } else {
                    setLocalesData([]);
                }

                if (response?.data?.tipos_de_reporte?.length > 0) {
                    setTipoReportes(response.data.tipos_de_reporte);
                    setTipoReportePaseo(response.data.tipos_de_reporte[0].nombre);
                } else {
                    setTipoReportes([]);
                }



            })
            .catch(error => {
                console.log("error==>getFiltroReporte", error);
                setDataPromociones([]);
                setLocalesData([]);

                setLoadingPromociones(false);
                setLoadingLocales(false);
            })
    };

    useEffect(() => {
        if (stateToken) {
            handleApiFiltrosOpciones();
        }
    }, [stateToken]);



























    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarPromocionesTituloEstado = () => {


        let body = {
            page: 1,
            per_page: 10,
            estado: "",
            titulo: buscarPromocion
        };
        // console.log("body", body);


        setLoadingPromociones(true);

        getFiltrarPromociones(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarPromociones", response);

                setLoadingPromociones(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setPromocionesData(response.data);
                } else {
                    setPromocionesData([]);
                }



            })
            .catch(error => {
                console.log("error==>getFiltrarPromociones", error);
                setPromocionesData([]);
                setLoadingPromociones(false);
            })
    };


    // useEffect(() => {
    //     const timeOutId = setTimeout(() => {
    //         if (buscarPromocion.length > 2) {

    //             handleApiFiltrarPromocionesTituloEstado();
    //         } else {
    //             handleApiFiltrarPromocionesTituloEstado();
    //         }
    //     }, 1500);
    //     return () => clearTimeout(timeOutId);

    // }, [stateToken, buscarPromocion]);








    //============================================================ funcion para filtrar locales
    const handleApiFiltrarLocales = () => {


        let body = {
            // page: 1,
            // per_page: 10,
            // estado: "",
            // titulo: buscarPromocion
            page: 1,
            per_page: 10,
            estado: "",
            nombre: buscarLocal,
            categoriaId: ""
        };
        // console.log("body", body);


        setLoadingLocales(true);

        getFiltrarLocales(stateToken?.access_token, body)
            .then(response => {
                // console.log("response==>getFiltrarLocales", response);

                setLoadingLocales(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setLocalesData(response.data);
                } else {
                    setLocalesData([]);
                }



            })
            .catch(error => {
                console.log("error==>getFiltrarLocales", error);
                setLocalesData([]);
                setLoadingLocales(false);
            })
    };


    // useEffect(() => {
    //     const timeOutId = setTimeout(() => {
    //         if (buscarLocal.length > 2) {

    //             handleApiFiltrarLocales();
    //         } else {
    //             handleApiFiltrarLocales();
    //         }
    //     }, 1500);
    //     return () => clearTimeout(timeOutId);

    // }, [stateToken, buscarLocal]);




    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">

                <ReportePaseoPlus
                    dataPromociones={dataPromociones}

                    statusOptionsPaseoPlus={tipoReportes}
                    tipoReportePaseo={tipoReportePaseo}
                    setTipoReportePaseo={setTipoReportePaseo}

                    promocionesData={promocionesData}
                    loadingPromociones={loadingPromociones}
                    promocionSelected={promocionSelected}
                    setPromocionSelected={setPromocionSelected}
                    buscarPromocion={buscarPromocion}
                    setBuscarPromocion={setBuscarPromocion}


                    localesData={localesData}
                    loadingLocales={loadingLocales}
                    localSelected={localSelected}
                    setLocalSelected={setLocalSelected}
                    buscarLocal={buscarLocal}
                    setBuscarLocal={setBuscarLocal}
                />

                <ReportesGiftCard />




                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                        {mensaje}
                    </Alert>
                </Snackbar>

                <Backdrop open={loadingCargar} sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default ReportesPage;